// Coreografia de ativação do SW novo usada pelo prompt de chunk-stale.
//
// Quando um chunk lazy falha SEM haver um SW em `waiting`, um reload cru
// reentraria no mesmo SW velho (serve o index.html precacheado antigo) e o
// chunk falharia de novo. `waitForWaitingWorker` dispara registration.update()
// e espera o SW novo instalar/chegar a `waiting` antes de o chamador pular para
// ele; no timeout (sem deploy novo — provável rede transitória) resolve `false`
// para o chamador cair no reload cru como último recurso.

export function waitForWaitingWorker(
  registration: ServiceWorkerRegistration,
  timeoutMs: number,
): Promise<boolean> {
  if (registration.waiting) return Promise.resolve(true);

  return new Promise<boolean>((resolve) => {
    let settled = false;
    const cleanupFns: Array<() => void> = [];

    function finish(found: boolean): void {
      if (settled) return;
      settled = true;
      cleanupFns.forEach((fn) => fn());
      resolve(found);
    }

    function watchInstalling(): void {
      const installing = registration.installing;
      if (!installing) return;
      const onStateChange = (): void => {
        if (installing.state === 'installed' && registration.waiting) finish(true);
      };
      installing.addEventListener('statechange', onStateChange);
      cleanupFns.push(() => installing.removeEventListener('statechange', onStateChange));
    }

    const onUpdateFound = (): void => watchInstalling();
    registration.addEventListener('updatefound', onUpdateFound);
    cleanupFns.push(() => registration.removeEventListener('updatefound', onUpdateFound));

    // Um updatefound pode já estar em andamento no momento do clique.
    watchInstalling();

    const timer = setTimeout(() => finish(false), timeoutMs);
    cleanupFns.push(() => clearTimeout(timer));

    void registration.update().catch(() => undefined);
  });
}
